<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Filled</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" color="primary" type="filled"
              >Primary</vs-button
            >
            <vs-button class="mr-1 my-1" color="success" type="filled"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="filled"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="filled"
              >Warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="filled">Dark</vs-button>
            <vs-button class="mr-1 my-1" color="rgb(134, 4, 98)" type="filled"
              >RGB</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="filled">Disabled</vs-button>
            <vs-button
              class="mr-1 my-1"
              color="primary"
              type="filled"
              to="/components/list.html"
              >Router</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Border</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" color="primary" type="border"
              >Primary</vs-button
            >
            <vs-button class="mr-1 my-1" color="success" type="border"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="border"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="border"
              >Warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="border">Dark</vs-button>
            <vs-button class="mr-1 my-1" color="rgb(134, 4, 98)" type="border"
              >RGB</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="border">Disabled</vs-button>
            <vs-button
              class="mr-1 my-1"
              color="primary"
              type="border"
              to="/components/list.html"
              >Router</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Flat</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" color="primary" type="flat"
              >Primary</vs-button
            >
            <vs-button class="mr-1 my-1" color="success" type="flat"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="flat"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="flat"
              >Warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="flat">Dark</vs-button>
            <vs-button class="mr-1 my-1" color="rgb(134, 4, 98)" type="flat"
              >RGB</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="flat">Disabled</vs-button>
            <vs-button
              class="mr-1 my-1"
              color="primary"
              type="flat"
              to="/components/list.html"
              >Router</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Line Down</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button type="line">Primary</vs-button>
            <vs-button
              class="mr-1 my-1"
              line-origin="left"
              color="success"
              type="line"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="line"
              >Danger</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              line-position="top"
              line-origin="left"
              color="warning"
              type="line"
              >Warning</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              line-position="top"
              line-origin="right"
              color="dark"
              type="line"
              >Dark</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="line">Disabled</vs-button>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Gradient</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" color="primary" type="gradient"
              >Primary</vs-button
            >
            <vs-button class="mr-1 my-1" color="success" type="gradient"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="gradient"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="gradient"
              >Warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="gradient"
              >Dark</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="#3dd495"
              gradient-color-secondary="rgb(130, 207, 23)"
              type="gradient"
              >RGB</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="gradient"
              >Disabled</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Relief</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" type="relief">Primary</vs-button>
            <vs-button class="mr-1 my-1" color="success" type="relief"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" type="relief"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="relief"
              >warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="relief">dark</vs-button>
            <vs-button class="mr-1 my-1" color="rgb(187, 138, 200)" type="relief"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" disabled type="relief">Disabled</vs-button>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <input
              class="mr-1 my-1"
              type="color"
              v-model="colorx"
              name=""
              value=""
            />
            <input
              class="mr-1 my-1"
              type="color"
              v-model="colorx2"
              name=""
              value=""
            />
            <vs-button class="mr-1 my-1" :color="colorx" type="filled"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" :color="colorx" type="border"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" :color="colorx" type="flat"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" :color="colorx" type="line"
              >Color</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              :color="colorx"
              :gradient-color-secondary="colorx2"
              type="gradient"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" :color="colorx" type="relief"
              >Color</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Text Color</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1">Primary</vs-button>
            <vs-button class="mr-1 my-1" color="success" text-color="rgb(10, 20, 30)"
              >Success</vs-button
            >
            <vs-button class="mr-1 my-1" color="danger" text-color="#aaff00"
              >Danger</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" text-color="primary"
              >warning</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" text-color="rgb(10, 20, 30)"
              >dark</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="rgb(187, 138, 200)"
              text-color="warning)"
              >Color</vs-button
            >
            <vs-button class="mr-1 my-1" disabled text-color="rgb(0, 0, 0)"
              >Disabled</vs-button
            >
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icon</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" color="primary" type="border" icon="home"
              >Home</vs-button
            >
            <vs-button class="mr-1 my-1" color="warning" type="filled" icon="star"
              >Star</vs-button
            >
            <vs-button class="mr-1 my-1" color="success" type="flat" icon="done"
              >Done</vs-button
            >
            <vs-button class="mr-1 my-1" color="dark" type="line" icon="menu"
              >menu</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="danger"
              type="gradient"
              icon="favorite"
              >favorite</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              disabled
              color="primary"
              type="border"
              icon="home"
              >Disabled</vs-button
            ><br /><br />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Icon Only</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button
              class="mr-1 my-1"
              color="primary"
              type="border"
              icon="search"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              color="warning"
              type="filled"
              icon="public"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              color="success"
              type="flat"
              icon="photo_camera"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              color="dark"
              type="line"
              icon="event_note"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              color="danger"
              type="gradient"
              icon="person_add"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              disabled
              color="primary"
              type="border"
              icon="search"
            ></vs-button>

            <vs-button
              class="mr-1 my-1"
              radius
              color="primary"
              type="border"
              icon="search"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              radius
              color="warning"
              type="filled"
              icon="public"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              radius
              color="success"
              type="flat"
              icon="photo_camera"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              radius
              color="dark"
              type="line"
              icon="event_note"
            ></vs-button>
            <vs-button
              class="mr-1 my-1"
              radius
              color="danger"
              type="gradient"
              icon="person_add"
            ></vs-button>
            <vs-button
              disabled
              radius
              color="primary"
              type="border"
              icon="search"
            ></vs-button
            ><br /><br />
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Size</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button class="mr-1 my-1" size="large">Large</vs-button>
            <vs-button class="mr-1 my-1">Default</vs-button>
            <vs-button class="mr-1 my-1" size="small">Small</vs-button>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Router</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-button
              class="mr-1 my-1"
              color="primary"
              type="filled"
              to="/components/list.html"
              >String literal</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="warning"
              type="filled"
              :to="{ path: '/components/list.html' }"
              >Object Path</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="success"
              type="filled"
              :to="{ name: 'user', params: { userId: 123 } }"
              >Named Router</vs-button
            >
            <vs-button
              class="mr-1 my-1"
              color="dark"
              type="filled"
              :to="{ path: 'register', query: { plan: 'private' } }"
              >With Query</vs-button
            >
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>